module.exports = __webpack_public_path__ + "img/card-s06.24ed2af5.jpg";